module.exports = __webpack_public_path__ + "static/media/banner_l_04.2eaedb61.jpg";